import { render, staticRenderFns } from "./UnknownField.vue?vue&type=template&id=120fd7c8"
import script from "./UnknownField.vue?vue&type=script&lang=js"
export * from "./UnknownField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports